export default __webpack_public_path__ + "static/media/logoFooter.0eedb68c.png";